module.exports = __webpack_public_path__ + "img/t1-headshot.b68fcb84.png";